import { Player } from "@kaltura/mediaspace-shared-player";
import React from "react";
import { CategoryHeaderProps } from "./CategoryHeaderProps";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { merge } from "ramda";
import Links from "./links/Links";
import { useTheme } from "@kaltura/mediaspace-shared-styled";
import {
    StyledChannelHeaderWrapper,
    StyledChannelHeader,
    StyledContentWrapper,
    StyledImage,
    StyledLogo,
    StyledMediaWrapper,
    StyledWrapper,
} from "./styled";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";
import { CategoryHeaderBasicMetadata } from "./CategoryHeaderBasicMetadata";

/**
 *  Channel page header
 */
export function ChannelHeader(props: CategoryHeaderProps) {
    const { image = "", bannerImage = "", logo = "", media = null, playerConfig = null, ...linksProps } = props;

    const theme = useTheme();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

    // width/height is different in case of kaf
    const configContext = useContext(ConfigContext);
    const isKaf = configContext.application?.isKAF;

    let adaptedPlayerConfig = playerConfig;
    if (media && playerConfig) {
        const cfg = {
            ui: {
                ...playerConfig.ui,
                uiComponents: [
                    {
                        label: "niceComponent1", // just a name of your component
                        presets: ["Playback"], // the presets where you want to apply it
                        container: "BottomBarLeftControls",
                        get: () => undefined, // your component, in your case you just wanna return undefined
                        replaceComponent: "Forward", // name of component you wanna replace
                    },
                    {
                        label: "niceComponent2", // just a name of your component
                        presets: ["Playback"], // the presets where you want to apply it
                        container: "BottomBarLeftControls",
                        get: () => undefined, // your component, in your case you just wanna return undefined
                        replaceComponent: "Rewind", // name of component you wanna replace
                    },
                    {
                        label: "niceComponent3", // just a name of your component
                        presets: ["Playback"], // the presets where you want to apply it
                        container: "BottomBarRightControls",
                        get: () => undefined, // your component, in your case you just wanna return undefined
                        replaceComponent: "Settings", // name of component you wanna replace
                    },
                    {
                        label: "niceComponent4", // just a name of your component
                        presets: ["Playback"], // the presets where you want to apply it
                        container: "BottomBarRightControls",
                        get: () => undefined, // your component, in your case you just wanna return undefined
                        replaceComponent: "PictureInPicture", // name of component you wanna replace
                    },
                ],
            },
        };
        adaptedPlayerConfig = merge(playerConfig, cfg);
    }

    return (
        <StyledChannelHeader
            className={"kms-ds-channel-page-header"}
            style={{
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundImage: `url("${image}")`,
            }}
        >
            <StyledChannelHeaderWrapper isKaf={isKaf} className={"kms-ds-channel-page-header-wrapper"}>
                {isSmallScreen && logo && <StyledLogo style={{ backgroundImage: `url(${logo})` }} />}
                <StyledWrapper isKaf={isKaf} className={"kms-ds-channel-page-header-content"}>
                    {!isSmallScreen && logo && <StyledLogo style={{ backgroundImage: `url(${logo})` }} />}
                    <StyledContentWrapper className={"kms-ds-channel-page-header-text"}>
                        <CategoryHeaderBasicMetadata {...props} isChannel={true} />
                        <Links {...linksProps} />
                    </StyledContentWrapper>
                    {media && playerConfig ? (
                        <StyledMediaWrapper isKaf={isKaf} className={"kms-ds-channel-page-header-video"}>
                            <Player media={media} config={adaptedPlayerConfig} />
                        </StyledMediaWrapper>
                    ) : (
                        bannerImage && (
                            <StyledMediaWrapper isKaf={isKaf} className={"kms-ds-channel-page-header-image"}>
                                <StyledImage src={bannerImage} role={"presentation"} />
                            </StyledMediaWrapper>
                        )
                    )}
                </StyledWrapper>
            </StyledChannelHeaderWrapper>
        </StyledChannelHeader>
    );
}

export default ChannelHeader;
